import Vue from 'vue'
import Router from 'vue-router'
import store from './store'


import Login from './views/user-session/Login.vue'
import ForgotPassword from './views/user-session/ForgotPassword.vue'
import CreateNewAccount from './views/user-session/CreateNewAccount.vue'
import ConfirmRegistration from './views/user-session/ConfirmRegistration.vue'
import ConfirmToken from './views/user-session/ConfirmToken.vue'
import ResendConfirmationToken from './views/user-session/ResendConfirmationToken.vue'
import ConfirmResetPasswordToken from './views/user-session/ConfirmResetPasswordToken.vue'


import Logout from './views/user-session/Logout.vue'

import Dashboard from './views/Dashboard.vue'
import TrackingOrders from './views/TrackingOrders.vue'
import Bookings from './views/Bookings.vue'
import BookingCreateNew from './views/BookingCreateNew.vue'
import BookingView from './views/BookingView.vue'
import Settings from './views/Settings.vue'
// import Reports from './views/Reports.vue'
import Clients from './views/Clients.vue'
import AddNewClient from './views/AddNewClient.vue'
import GetClient from './views/admin/client/GetClient.vue'

import Users from './views/admin/file-maintenance/users/List.vue'
import AddUser from './views/admin/file-maintenance/users/Add.vue'
import Warehouses from './views/admin/file-maintenance/warehouses/List.vue'
import AddWarehouse from './views/admin/file-maintenance/warehouses/Add.vue'

import Locations from './views/admin/file-maintenance/locations/List.vue'
import AddLocation from './views/admin/file-maintenance/locations/Add.vue'

import Invoices from './views/Invoices.vue'
import InvoiceView from './views/InvoiceView.vue'
import Invoice from './views/accountant/Invoice.vue'

import DeliveryOrders from './views/DeliveryOrders.vue'
import DeliveryOrderView from './views/DeliveryOrderView.vue'
import DeliveryOrder from './views/operations/DeliveryOrder.vue'

import ClientDeliveryToReceive from './views/client/delivery/ToReceive.vue'
import ClientDeliveryReceived from './views/client/delivery/Received.vue'

import RptBooking from './views/reports/RptBooking.vue'
import RptSales from './views/reports/RptSales.vue'
import RptCsrSales from './views/reports/RptCsrSales.vue'
import RptDispatching from './views/reports/RptDispatching.vue'
import RptUsers from './views/reports/RptUsers.vue'

import Containers from './views/admin/container/Containers.vue'
import ContainerView from './views/admin/container/ContainerView.vue'

import RewardClientsView from './views/RewardClients.vue'
import RewardClientDetails from './views/RewardClientDetails.vue'
import ClientRewardView from './views/client/reward/View.vue'


Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: '/app',
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '/rewards/clients',
      name: 'rewards-clients',
      component: RewardClientsView,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/rewards/clients/:slug',
      name: 'rewards-clients-view',
      component: RewardClientDetails,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/rewards',
      name: 'client-rewards',
      component: ClientRewardView,
      meta: {
        requiresAuth: true
      }
    },



    {
      path: '/reports/bookings',
      name: 'rpt-bookings',
      component: RptBooking,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/reports/sales',
      name: 'rpt-sales',
      component: RptSales,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: '/reports/csr-sales',
      name: 'rpt-csr-sales',
      component: RptCsrSales,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/reports/dispaching',
      name: 'rpt-dispaching',
      component: RptDispatching,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/reports/users',
      name: 'rpt-users',
      component: RptUsers,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/tracking-orders',
      name: 'tracking-orders',
      component: TrackingOrders,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: '/bookings/list/view/:id',
      name: 'booking-view',
      component: BookingView,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/bookings/list',
      name: 'bookings',
      component: Bookings,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/bookings/list/:page',
      name: 'bookings-page',
      component: Bookings,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/bookings/list/book/:id',
      name: 'booking',
      component: BookingCreateNew,
      meta: {
        // requiresAuth: true
      }
    },




    {
      path: '/clients/list',
      name: 'clients',
      component: Clients,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/clients/list/make/:slug',
      name: 'clients-info',
      component: AddNewClient,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/clients/list/get/:slug',
      name: 'clients-get',
      component: GetClient,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/clients/list/:page',
      name: 'clients-page',
      component: Clients,
      meta: {
        requiresAuth: true
      }
    },



    {
      path: '/users/list',
      name: 'users',
      component: Users,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/users/list/:page',
      name: 'users-page',
      component: Users,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/users/list/make/:id',
      name: 'user',
      component: AddUser,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: '/warehouses/list',
      name: 'warehouses',
      component: Warehouses,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/warehouses/list/:page',
      name: 'warehouses-page',
      component: Warehouses,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/warehouses/list/make/:id',
      name: 'warehouse',
      component: AddWarehouse,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/deliveries/to-receive',
      name: 'delivery-to-receive',
      component: ClientDeliveryToReceive,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/deliveries/to-receive/:page',
      name: 'delivery-to-receive-page',
      component: ClientDeliveryToReceive,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: '/deliveries/received',
      name: 'delivery-received',
      component: ClientDeliveryReceived,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/deliveries/received/:page',
      name: 'delivery-received-page',
      component: ClientDeliveryReceived,
      meta: {
        requiresAuth: true
      }
    },




    {
      path: '/locations/list',
      name: 'locations',
      component: Locations,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/locations/list/:page',
      name: 'locations-page',
      component: Locations,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/locations/list/make/:id',
      name: 'location',
      component: AddLocation,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: '/containers/list/view/:name',
      name: 'container-view',
      component: ContainerView,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/containers/list',
      name: 'containers',
      component: Containers,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/containers/list/:page',
      name: 'containers-page',
      component: Containers,
      meta: {
        requiresAuth: true
      }
    },


    {
      path: '/invoices/list/view/:id',
      name: 'invoice-view',
      component: InvoiceView,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/invoices/list',
      name: 'invoices',
      component: Invoices,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/invoices/list/:page',
      name: 'invoices-page',
      component: Invoices,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/invoices/list/make/:id',
      name: 'invoice',
      component: Invoice,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: '/delivery-orders/list/view/:id',
      name: 'delivery-view',
      component: DeliveryOrderView,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/delivery-orders/list',
      name: 'delivery-orders',
      component: DeliveryOrders,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/delivery-orders/list/:page',
      name: 'delivery-orders-page',
      component: DeliveryOrders,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/delivery-orders/list/make/:id',
      name: 'delivery',
      component: DeliveryOrder,
      meta: {
        requiresAuth: true
      }
    },


    {
      path: '/settings',
      name: 'settings',
      component: Settings,
      meta: {
        requiresAuth: true
      }
    },
    // {
    //   path: '/reports',
    //   name: 'reports',
    //   component: Reports,
    //   meta: {
    //     requiresAuth: true
    //   }
    // },
    {
      path: '/forgot-password',
      name: 'forgot-password',
      component: ForgotPassword
    },



    {
      path: '/confirm-registration',
      name: 'confirm-registration',
      component: ConfirmRegistration
    },
    {
      path: '/confirm-token',
      name: 'confirm-token',
      component: ConfirmToken
    },
    {
      path: '/resend-confirmation-token',
      name: 'resend-confirmation-token',
      component: ResendConfirmationToken
    },
    {
      path: '/confirm-reset-password-token',
      name: 'confirm-reset-password-token',
      component: ConfirmResetPasswordToken
    },
    {
      path: '/create-new-account',
      name: 'create-new-account',
      component: CreateNewAccount
    },
    {
      path: '/create-new-account/:code',
      name: 'create-new-account-code',
      component: CreateNewAccount
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        checkAppSession: true
      }
    },
    {
      path: '/logout',
      name: 'logout',
      component: Logout,
      meta: {
        requiresAuth: true
      }
    }


  ]
})


router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!store.state.signedIn) {
      next({ name: 'login' })
    } else {
      next() // go to wherever I'm going
    }
  } else if (to.matched.some(record => record.meta.checkAppSession)) {
    if (store.state.signedIn) {
      next({ name: 'dashboard' })
    } else {
      next() // go to wherever I'm going
    }
  } else {
    next() // does not require auth, make sure to always call next()!
  }
})

export default router
